import { Alert, Spinner, Button as ReactButton } from '@a-ui/react';
import React from 'react';
import Appointment from '../../components/Appointment';
import Typography from '../../components/Typography';
import { api } from '../../hooks/api.hooks';
import { translate } from '../../i18n';
import { usePagination } from './hooks';

interface ECounterAppointmentsProps {}

const ECounterAppointments: React.FC<ECounterAppointmentsProps> = () => {
  const [isLoading, setLoading] = React.useState(true);
  const { items, hasMore, loadMore, setHasMore } = usePagination<Api.Appointment>(
    async (offset: number, limit: number) => {
      setLoading(true);

      const { data } = await api.get<Api.Paginated<Api.Appointment>>('/activities/appointments', {
        params: {
          offset,
          limit,
        },
      });

      setHasMore(!!data?._links?.next);
      setLoading(false);
      return data?._embedded?.appointments;
    },
  );

  return (
    <div className="u-margin-top">
      {!items.length && isLoading && <Spinner />}

      {!items.length && !isLoading && (
        <Alert inline className="u-margin-bottom">
          <Typography>{translate('ecounter.appointments.empty')}</Typography>
        </Alert>
      )}

      {items.map((appointment) => (
        <Appointment key={appointment.id} data={appointment} />
      ))}

      {items.length > 0 && hasMore && (
        <div className="u-margin-top">
          <ReactButton
            theme="neutral"
            onClick={loadMore}
            {...(isLoading ? { addOn: { type: 'spinner', align: 'left' } } : {})}
          >
            {translate('ecounter.appointments.load_more')}
          </ReactButton>
        </div>
      )}
    </div>
  );
};

export default ECounterAppointments;
